import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dateFormat from 'dateformat';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import propTypes from './prop-types';
import { getDateTimeFormat } from '#helper';

const StopDialog = props => {
  const {
    showDialog,
    onClose,
    onStop,
    appliance
  } = props;

  const measurementSystem = useSelector(s => s.account.measurementSystem);
  const [error, setError] = useState(null);
  const [stopDate, setStopDate] = useState(new Date());

  const formatFns = useMemo(() => getDateTimeFormat(measurementSystem, 'dateTimeShortDateFns'), [measurementSystem]);
  const dateTimeFormat = useMemo(() => getDateTimeFormat(measurementSystem, 'dateTimeShort'), [measurementSystem]);

  const handleOk = async () => {
    onStop({ stopDate });
  };

  const minDate = appliance?.startDate;

  useEffect(() => {
    if (showDialog) {
      setStopDate(new Date());
    }
  }, [showDialog]);

  const handleDateChange = date => {
    if (error) {
      setError(null);
    }

    if (Date.parse(date)) {
      if (minDate && date.toISOString() < minDate) {
        setError(`Must be after ${dateFormat(minDate, dateTimeFormat)}`);
      } else if (date > new Date()) {
        setError(`Must be earlier than ${dateFormat(new Date(), dateTimeFormat)}`);
      }
      setStopDate(date);
    } else {
      setError('Invalid date format');
    }
  };

  return (
    <Dialog
      open={showDialog}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>
        Stop appliance
      </DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Stop date"
            inputVariant="outlined"
            format={formatFns}
            value={new Date(stopDate)}
            onChange={handleDateChange}
            minDate={new Date(minDate)}
            maxDate={new Date()}
            strictCompareDates
            disabled={new Date(minDate) > new Date()}
            slotProps={{
              textField: {
                error: !!error,
                helperText: error
              }
            }}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary" autoFocus disabled={!!error}>
          Stop
        </Button>
      </DialogActions>
    </Dialog>
  );
};

StopDialog.propTypes = propTypes;

export default StopDialog;
